import { View } from "../../view";
import { Template, LazyTemplate } from "../../template/index";

export default class ErrorView extends View
{
    template = Template.lazy('/core/views/error/index.html');
    private errorMessage: string;

    constructor(error: Error)
    {
        super();
        this.errorMessage = error.message;
    }
}